<template>
  <div class="ml-4">
    <p class="mt-1 max-w-2xl text-xs leading-5 text-gray-500">
      By {{ message.userDisplay }} on {{ postDate }}
    </p>
    <vue-markdown :source="message.body" class="mt-2 prose text-gray-900 font-medium"></vue-markdown>
    <div
      v-if="imageAttachments.length > 0"
      class="flex flex-row flex-wrap justify-start"
    >
      <div
        v-for="attachment in imageAttachments"
        :key="attachment.key"
        class="p-2"
      >
        <attachment-display :attachment="attachment"></attachment-display>
      </div>
    </div>
    <div
      v-if="fileAttachments.length > 0"
      class="flex flex-col justify-start border border-gray-300 rounded-lg p-2"
    >
      <span class="uppercase px-2 pb-2 text-darkpurple text-sm font-bold"
        >attachments</span
      >
      <div v-for="attachment in fileAttachments" :key="attachment.key" class="">
        <attachment-display :attachment="attachment"></attachment-display>
      </div>
    </div>
  </div>
</template>

<script>
import AttachmentDisplay from "./AttachmentDisplay";
import VueMarkdown from "vue-markdown";

export default {
  name: "TopicMessageDisplay",
  components: {
    AttachmentDisplay,
    VueMarkdown
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      modal: false
    };
  },
  methods: {},
  computed: {
    postDate() {
      if (this.message.timestamp) {
        return this.message.timestamp.toDate().toLocaleString();
      }
      return "";
    },
    imageAttachments() {
      let images = [];
      if (this.message.attachments) {
        images = this.message.attachments.filter(at =>
          at.key.includes("images/")
        );
      }
      return images;
    },
    fileAttachments() {
      let files = [];
      if (this.message.attachments) {
        files = this.message.attachments.filter(
          at => at.key.includes("images/") === false
        );
      }
      return files;
    }
  }
};
</script>

<style scoped></style>
